// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3z3dd","title":"Header_title__3o0X_","left":"Header_left__221Uq","clinicName":"Header_clinicName__25m1G"};